import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { InitDataResponse } from '../dtos/init-data.response.dto';

@Injectable({ providedIn: 'root' })
export class AppInitService {
    private readySubject = new BehaviorSubject<boolean>(false);

    initData: InitDataResponse = null;

    /** True, ha az AppComponent inicializ�l�sa (login, token, init adatok) befejez�d�tt. */
    get isReady(): boolean {
        return this.readySubject.value;
    }

    /** Jelzi, hogy az app inicializ�l�s k�sz. T�bbsz�r is h�vhat�. */
    markReady(): void {
        if (!this.readySubject.value) {
            this.readySubject.next(true);
        }
    }

    /** Egyszer emitt�l (majd lez�rul), amint az app k�szen �ll a page-ek adatlek�r�seihez. */
    whenReady(): Observable<void> {
        return this.readySubject.pipe(
            filter(ready => ready),
            take(1),
            map(() => void 0)
        );
    }
}